export default __webpack_public_path__ + "static/media/RMS-EndCard-BPIDfromMDD.2991b5f8.jpg";